import { render } from "./GlossaryModal.vue?vue&type=template&id=47d5ef54&scoped=true"
import script from "./GlossaryModal.vue?vue&type=script&lang=js"
export * from "./GlossaryModal.vue?vue&type=script&lang=js"

import "./GlossaryModal.vue?vue&type=style&index=0&id=47d5ef54&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47d5ef54"

export default script